import React from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
  TooltipProvider,
} from "@/components/ui/tooltip";

interface ShortenedPathProps {
  folderPath: string;
  maxLength?: number;
}

const ShortenedPath: React.FC<ShortenedPathProps> = ({ folderPath, maxLength = 30 }) => {
  const shortenPath = (path: string, maxLen: number): string => {
    if (path.length <= maxLen) {
      return path;
    }
    const start = path.slice(0, maxLen);
    return `${start}...`;
  };

  const shortenedPath = shortenPath(folderPath, maxLength);

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="text-xs truncate">
            {shortenedPath}
          </span>
        </TooltipTrigger>
        <TooltipContent side="bottom" align="start">
          {folderPath}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default ShortenedPath;
